import { formatarPreco, parsePreco } from "./preco";

// Monta o texto do pedido que vai para o WhatsApp do restaurante.
// O total da mensagem é exatamente o mesmo da tela (soma dos itens); a entrega fica
// "a combinar" porque o app não calcula frete (o cálculo antigo pelo CEP era inventado).

export const FORMAS_PAGAMENTO = {
  pix: "Pix",
  cartao: "Cartão (na entrega/retirada)",
  dinheiro: "Dinheiro",
};

export const subtotalDosItens = (itens) =>
  itens.reduce((total, item) => total + parsePreco(item.preco) * item.quantidade, 0);

// Telefone do restaurante só com dígitos e com o 55 do Brasil (formato do wa.me).
export const numeroWhatsapp = (numero) => {
  const digitos = String(numero || "").replace(/\D/g, "");
  if (!digitos) return null;
  if (digitos.startsWith("55") && digitos.length >= 12) return digitos;
  return digitos.length >= 10 ? `55${digitos}` : null;
};

const linhaEndereco = (e) => {
  const rua = [e.rua, e.numero].filter(Boolean).join(", ");
  const partes = [rua, e.complemento, e.bairro].filter(Boolean).join(" - ");
  return e.cep ? `${partes} (CEP ${e.cep})` : partes;
};

export const montarMensagemPedido = ({ itens, cliente, restauranteNome, agora = new Date() }) => {
  const subtotal = subtotalDosItens(itens);
  const linhas = [];

  linhas.push(`*NOVO PEDIDO${restauranteNome ? ` - ${restauranteNome}` : ""}*`);
  linhas.push(`Data: ${agora.toLocaleString("pt-BR")}`);
  linhas.push("");
  linhas.push("*Itens*");
  itens.forEach((item) => {
    const preco = parsePreco(item.preco);
    linhas.push(`${item.quantidade}x ${item.nome} - ${formatarPreco(preco * item.quantidade)}`);
    if (item.quantidade > 1) linhas.push(`   (${formatarPreco(preco)} cada)`);
    if (item.observacao) linhas.push(`   Obs.: ${item.observacao}`);
  });
  linhas.push("");
  linhas.push(`Subtotal: ${formatarPreco(subtotal)}`);
  if (cliente.tipo === "entrega") linhas.push("Entrega: a combinar");
  linhas.push(`*Total: ${formatarPreco(subtotal)}*${cliente.tipo === "entrega" ? " + entrega" : ""}`);
  linhas.push("");
  linhas.push(cliente.tipo === "entrega" ? "*Entrega*" : "*Retirada no local*");
  linhas.push(`Nome: ${cliente.nome}`);
  if (cliente.telefone) linhas.push(`Telefone: ${cliente.telefone}`);
  if (cliente.tipo === "entrega") linhas.push(`Endereço: ${linhaEndereco(cliente.endereco || {})}`);
  if (cliente.tipo === "entrega" && cliente.endereco?.referencia) linhas.push(`Referência: ${cliente.endereco.referencia}`);
  linhas.push("");
  linhas.push(`Pagamento: ${FORMAS_PAGAMENTO[cliente.pagamento] || "a combinar"}`);
  if (cliente.pagamento === "dinheiro" && cliente.troco) linhas.push(`Troco para: ${cliente.troco}`);
  if (cliente.observacao) {
    linhas.push("");
    linhas.push(`Observação do pedido: ${cliente.observacao}`);
  }
  linhas.push("");
  linhas.push("Aguardo a confirmação do pedido!");

  return linhas.join("\n");
};

export const linkWhatsapp = (numero, mensagem) => {
  const destino = numeroWhatsapp(numero);
  return destino ? `https://wa.me/${destino}?text=${encodeURIComponent(mensagem)}` : null;
};
